import {Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {PagedRequestDTO} from 'src/app/modules/common/models/PagedRequestDTO';
import {Observable} from 'rxjs';
import {PagedResponseDTO} from 'src/app/modules/common//models/PagedResponseDTO';
import {MasterDrugDTO} from 'src/app/modules/pbm/models/MasterDrugDTO';
import {environment} from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class MasterDrugService {

  private url = environment.baseUrl + '/master-drug';

  constructor(private httpClient: HttpClient) {
  }

  getListOfMasterDrugs(pagedRequestDTO: PagedRequestDTO): Observable<PagedResponseDTO<MasterDrugDTO>> {
    return this.httpClient.post<PagedResponseDTO<MasterDrugDTO>>(this.url + '/filter', pagedRequestDTO);
  }

  saveMasterDrug(masterDrugDTO: MasterDrugDTO): Observable<MasterDrugDTO> {
    return this.httpClient.post<MasterDrugDTO>(this.url, masterDrugDTO);
  }

  deleteMasterDrug(masterDrugId: number): Observable<{}> {
    return this.httpClient.delete<{}>(this.url + '/' + masterDrugId);
  }

  getMasterDrug(masterDrugId: number): Observable<MasterDrugDTO> {
    return this.httpClient.get<MasterDrugDTO>(this.url + '/' + masterDrugId);
  }

}
